import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadScimToken } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { GetScimTokensStaticFilter } from '../../endpoints/scim';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { scimQueryKey } from './invalidate-scim-queries';

export type GetScimTokensParams = GetCollectionQueryParams<
  ReadScimToken,
  GetScimTokensStaticFilter
>;

export const getScimTokens = async (
  params: GetScimTokensParams,
): Promise<ApiCollectionResponse<ReadScimToken>> => {
  return await tinctApi.scim.getScimTokens(params);
};

/**
 * The workspace's unrevoked SCIM tokens, oldest first. No value among them: a token is only ever
 * shown by the answer that created it. A refused read is not retried.
 */
export const useGetScimTokens = (
  params: GetScimTokensParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadScimToken>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: [
      ...scimQueryKey(params.staticParams?.organizationId ?? ''),
      'tokens',
      params,
    ],
    queryFn: () => getScimTokens(params),
    retry: false,
    ...options,
  });
